// api type
export const TOYA_API_TYPE = 'toya'
export const STREAMIQ_API_TYPE = 'streamiq'
export const PLATFORM_SMARTTV = 'smarttv'

//assets type
export const vodAssetType = 'VOD'
export const tvAssetType = 'TIVI'
export const cutvAssetType = 'CUTV'

export type Page = 'VOD' | 'HOME' | 'TV' | 'EPG' | 'SERIES'

export enum assetsTypes {
    TIVI = 'TIVI',
    VOD = 'VOD',
    CUTV = 'CUTV',
}

export const mobileKeyword = 'Mobile'
export const desktopKeyword = 'Desktop'

export const maxContainerWidth = 1919
export const searchQueryLimit = 100
export const minCharSearchLimit = 3

export const weekDays = [
    'Sunday',
    'Monday',
    'Tuesday',
    'Wednesday',
    'Thursday',
    'Friday',
    'Saturday',
]

//debounce
export const debounceSpeedShort = 100
export const debounceSpeedMedium = 200
export const debounceSpeedLong = 500
export const debounceSpeed1000 = 1000

//Settings page
export const settingsPagePath = '/settingsPage'
export const faqPagePath = '/faq'
export const profilePagePath = 'https://eboa.toya.net.pl/auth/login'
export const termsOfServicePagePath = '/terms-of-service'
export const TCPage = '/termsAndConditions'

//day times in milis
export const morningTimeStartHour = 6 * 60 * 60 * 1000
export const afternoonTimeStartHour = 13 * 60 * 60 * 1000
export const eveningTimeStartHour = 18 * 60 * 60 * 1000

// inputs type
export const inputPassword = 'password'

// other paths
export const emptyPath = '/'

// logo placeholders
export const loginScreenLogoUrlPlaceholder =
    'https://storage.googleapis.com/toya-334417.appspot.com/static/f72e63da3ac6bbadd2bbfb49cfec/login_screen_logo.png'
export const menuLogoUrlPlaceholder =
    'https://storage.googleapis.com/toya-334417.appspot.com/static/f72e63da3ac6bbadd2bbfb49cfec/menu_logo.png'

// login
export const minUserNameLength = 3
export const maxUserNameLength = 20

export const minPasswordLength = 5
export const maxPasswordLength = 25

// Profiles
export const defaultProfile = {
    iconId: '',
    default: true,
    id: '1',
    isKid: false,
    order: 'lcn',
    profile_name: 'User',
    version: 1,
    pin: 0,
}
export const MAX_PROFILES_LIMIT = 5
export const MAX_PIN_LENGTH = 4

export const refreshInterval = 50 * 60 * 1000
export const pollingInterval = 5 * 1000

export const TOP_MENU_HEIGHT = 100

export const IS_COOKIES_ACCEPTED = 'cookiesAccepted'

export const apiType = process.env.REACT_APP_API_TYPE as 'streamiq' | 'toya'
export const LAST_ACTUAL_PROFILE = 'lastActualProfile'
